import {Injectable} from '@angular/core';
import {Apollo} from 'apollo-angular';
import {CategoriaModel, SubcategoriaModel} from '../models/categoria.model';
import {
  ALLCATEGORIAS,
  ALLSUBCATEGORIAS,
  EDITCATEGORIA,
  EDITSUBCATEGORIA,
  GETCATEGORIA,
  GETSUBCATEGORIA,
  NEWCATEGORIA, NEWSUBCATEGORIA
} from '../queries/categoria.query';

@Injectable()
export class CategoriasServices {
  constructor(private apollo: Apollo) {
  }

  getAllCategorias() {
    return this.apollo.query({
      query: ALLCATEGORIAS
    });
  }

  getCategoria(id: any) {
    return this.apollo.query({
      query: GETCATEGORIA,
      variables: {
        id: id
      }
    });
  }

  updateCategoria(categoria: CategoriaModel) {

    let data = JSON.stringify({
      nombre:categoria.nombre,
      orden:categoria.orden
    });

    return this.apollo.mutate({
      mutation: EDITCATEGORIA,
      variables: {
        id: categoria._id,
        cat: data
      }
    });
  }

  newCategoria(categoria: CategoriaModel) {
    let data = JSON.stringify(categoria);

    return this.apollo.mutate({
      mutation: NEWCATEGORIA,
      variables: {
        cat: data
      }
    });
  }

  deleteCategoria(id: any) {
    // return this.apollo.mutate({
    //   mutation: '',
    //   variables: {
    //     id: id
    //   }
    // });
  }

  getAllSubCategorias() {
    return this.apollo.query({
      query: ALLSUBCATEGORIAS
    });
  }

  getSubCategoria(id: any) {
    return this.apollo.query({
      query: GETSUBCATEGORIA,
      variables: {
        id: id
      }
    });
  }

  updateSubCategoria(subcat: SubcategoriaModel) {

    let data = JSON.stringify({
      nombre:subcat.nombre,
      orden:subcat.orden,
      categoria: subcat.categoria._id
    });

    return this.apollo.mutate({
      mutation: EDITSUBCATEGORIA,
      variables: {
        id: subcat._id,
        subcat: data
      }
    });
  }

  newSubCategoria(subcat: SubcategoriaModel) {
    let data = JSON.stringify(subcat);

    return this.apollo.mutate({
      mutation: NEWSUBCATEGORIA,
      variables: {
        subcat: data
      }
    });
  }

  deleteSubCategoria(id: any) {
    // return this.apollo.mutate({
    //   mutation: '',
    //   variables: {
    //     id: id
    //   }
    // });
  }


}
